import React, { useState } from 'react'
import { Trans, t } from '@lingui/macro'
import ManageUsersPageContainer from './ManageUsersPageContainer'
import { staticLinks } from 'shared/linkBuilder'
import { navigateTo } from '../../app/util/appHistory'
import { Page } from '../../components/common/page/Page'
import { ButtonPrimary, ButtonOutline } from 'front-end/src/components'
import PageHeader from '../../components/common/page/header/PageHeader'
import { CreateUserModal } from './components/create-user-modal/CreateUserModal'
import { UsersList } from './components/UsersList'
import './ManageUsersPage.less'
import HeadTitle from '../../components/common/head/HeadTitle'
import IconPlus2 from 'front-end/src/components/common/icon/IconPlus2'

export const ManageUsersPage = () => {
  const [showCreateUserModal, setShowCreateUserModal] = useState(false)

  return (
    <ManageUsersPageContainer>
      <HeadTitle title={t`People`} />
      <Page className="ManageUsersPage">
        <PageHeader
          className="PageHeader"
          title={t`People`}
          controls={
            <>
              <ButtonOutline
                onClick={() => navigateTo(staticLinks.userImports)}
              >
                <Trans>Bulk user import</Trans>
              </ButtonOutline>
              <ButtonPrimary
                onClick={() => setShowCreateUserModal(true)}
                leftIcon={<IconPlus2 />}
              >
                <Trans>Add new user</Trans>
              </ButtonPrimary>
            </>
          }
        />
        <UsersList />
        <CreateUserModal
          show={showCreateUserModal}
          onHide={() => setShowCreateUserModal(false)}
        />
      </Page>
    </ManageUsersPageContainer>
  )
}
